import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Card, Typography, TextField, Button, Alert } from '@mui/material';
import { adminTheme } from './theme';
import './admin.css';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const url = `/user/login?mail=${encodeURIComponent(email)}&pass=${encodeURIComponent(password)}`;
            const res = await fetch(url, { method: 'POST' });
            if (res.status === 403 || res.status === 404) {
                setError('Неверный email или пароль');
                return;
            }
            if (!res.ok) {
                setError('Ошибка входа');
                return;
            }
            const token = await res.text();
            localStorage.setItem('token', token);
            navigate('/admin/products');
        } catch {
            setError('Ошибка сети');
        }
    };

    return (
        <div className="admin-scope">
            <ThemeProvider theme={adminTheme}>
                <Box sx={{
                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                    minHeight: '100vh', bgcolor: 'background.default',
                }}>
                    <Card sx={{ p: 4, width: 380 }}>
                        <Typography variant="h5" textAlign="center" sx={{ mb: 0.5 }}>
                            Админ-панель
                        </Typography>
                        <Typography color="text.secondary" textAlign="center" sx={{ mb: 3 }}>
                            iCandy Online
                        </Typography>
                        <form onSubmit={handleSubmit}>
                            <TextField label="Email" type="email" fullWidth required
                                value={email} onChange={e => setEmail(e.target.value)}
                                sx={{ mb: 2 }} size="small" />
                            <TextField label="Пароль" type="password" fullWidth required
                                value={password} onChange={e => setPassword(e.target.value)}
                                sx={{ mb: 2 }} size="small" />
                            {error && <Alert severity="error" sx={{ mb: 2, fontSize: 14 }}>{error}</Alert>}
                            <Button type="submit" variant="contained" fullWidth size="large">
                                Войти
                            </Button>
                        </form>
                    </Card>
                </Box>
            </ThemeProvider>
        </div>
    );
};

export default LoginPage;
